import React, { useRef, useState } from 'react';
import Modal from 'react-bootstrap/Modal';

import useTableScroll from "../components/useTableScroll.js";

import { Mensaje } from '../components/mensajes';
import axios from "axios";
import moment from 'moment';
import { Dimmer } from "../components/spinner";
import { formatMoneda } from '../util/varios.js';


const CatalogoImputaciones = props => {

    let op = require('../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');
    const idefiscal = JSON.parse(localStorage.getItem('idefiscal'));
    const espiritu = JSON.parse(localStorage.getItem('espiritu'));

    const btnCancela = useRef();
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [activate, setActivate] = useState(false);
    const [records, setRecords] = useState([]);
    const [values, setValues] = useState({});
    const [activo, setActivo] = useState(true);
    const [itemSelect, setItemSelect] = useState(-1);
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const headCells = [
        { label: 'CÓDIGO', textAlign: 'center' },
        { label: 'RAZÓN SOCIAL', textAlign: 'center' },
        { label: 'CONCEPTO', textAlign: 'center' },
    ]

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTableScroll(records, headCells, filterFn);

    const handleSearch = e => {
        let target = e.target;

        setFilterFn({
            fn: items => {
                if (target.value === "") {
                    return items;
                } else {
                    return items.filter(x => {
                        if (x.codigoorden.includes(target.value)
                            || x.razonsocial.toLowerCase().includes(target.value.toLowerCase())
                            || x.concepto.toLowerCase().includes(target.value.toLowerCase())) {
                            return x;
                        }
                    });
                }
            }
        })

    }

    const seleccionarOrdenesCompras = () => {


        let endpoint = `${op.conexion}/api/presupuesto/registrosimputacioncat?idefiscal=${idefiscal}&spiritu=${espiritu}&status=${props.estatus}&aprobado=${props.aprueba}`;
        console.log(endpoint)
        setActivate(true);

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status === 200) {

                setActivate(false);
                var data = []
                for (let i = 0; i < response.data.length; i++) {
                    data.push({
                        tipodocumento: response.data[i].tipodocumento,
                        codigoorden: response.data[i].codigoorden,
                        tipoorden: response.data[i].tipoorden,
                        idordencompra: response.data[i].idordencompra,
                        status: response.data[i].status,
                        fecha: response.data[i].fecha,
                        observaciones: response.data[i].observaciones,
                        tipo: response.data[i].tipo,
                        concepto: response.data[i].concepto,
                        escredito: response.data[i].escredito,
                        numcontrol: response.data[i].numcontrol,
                        idefiscal: response.data[i].idefiscal,
                        monto: response.data[i].monto,
                        montoiva: response.data[i].montoiva,
                        idproveedor: response.data[i].idproveedor,
                        idcordinacion: response.data[i].idcordinacion,
                        idusuario_crea: response.data[i].idusuario_crea,
                        fecha_crea: response.data[i].fecha_crea,
                        fecha_reverso: response.data[i].fecha_reverso,
                        idusuario_reversa: response.data[i].idusuario_reversa,
                        reversado: response.data[i].reversado,
                        motivo: response.data[i].motivo,
                        razonsocial: response.data[i].razonsocial,
                        idordenservicio: response.data[i].idordenservicio
                    })
                }
                setRecords(data)
            }


        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });

        }).finally(function () {
            setActivate(false);
        });

    }

    const blanquear = () => {
        setActivate(false);
        setRecords([]);
        setFilterFn({ fn: items => { return items; } });
        setItemSelect("");
        setActivo(true);
    }


    const cancelar = () => {

        blanquear();
        props.onHideCancelar();
    }

    const selectOrden = () => {

        var tipodocumento = values[0].tipodocumento;
        var codigoorden = values[0].codigoorden;
        var tipoorden = values[0].tipoorden;
        var idordencompra = values[0].idordencompra;
        var status = values[0].status;
        var fecha = values[0].fecha;
        var observaciones = values[0].observaciones;
        var tipo = values[0].tipo;
        var concepto = values[0].concepto;
        var escredito = values[0].escredito;
        var numcontrol = values[0].numcontrol;
        var idefiscal = values[0].idefiscal;
        var monto = values[0].monto;
        var montoiva = values[0].montoiva;
        var idproveedor = values[0].idproveedor;
        var idcordinacion = values[0].idcordinacion;
        var idusuario_crea = values[0].idusuario_crea;
        var fecha_crea = values[0].fecha_crea;
        var fecha_reverso = values[0].fecha_reverso;
        var idusuario_reversa = values[0].idusuario_reversa;
        var reversado = values[0].reversado;
        var motivo = values[0].motivo;
        var razonsocial = values[0].razonsocial;
        var idordenservicio = values[0].idordenservicio;

        blanquear();
        props.onHideAceptarCompromiso(tipodocumento, codigoorden, tipoorden, idordencompra, status, fecha, observaciones, tipo, concepto, escredito,
            numcontrol, idefiscal, monto, montoiva, idproveedor, idcordinacion, idusuario_crea, fecha_crea, fecha_reverso, idusuario_reversa,
            reversado, motivo, razonsocial, idordenservicio);
        props.onHideCancelar();
    };

    const seleccionarFila = (index) => (e) => {
        e.preventDefault();
        setItemSelect(index);
        setActivo(false);

        var tipodocumento = recordsAfterPagingAndSorting()[index].tipodocumento;
        var codigoorden = recordsAfterPagingAndSorting()[index].codigoorden;
        var tipoorden = recordsAfterPagingAndSorting()[index].tipoorden;
        var idordencompra = recordsAfterPagingAndSorting()[index].idordencompra;
        var status = recordsAfterPagingAndSorting()[index].status;
        var fecha = recordsAfterPagingAndSorting()[index].fecha;
        var observaciones = recordsAfterPagingAndSorting()[index].observaciones;
        var tipo = recordsAfterPagingAndSorting()[index].tipo;
        var concepto = recordsAfterPagingAndSorting()[index].concepto;
        var escredito = recordsAfterPagingAndSorting()[index].escredito;
        var numcontrol = recordsAfterPagingAndSorting()[index].numcontrol;
        var idefiscal = recordsAfterPagingAndSorting()[index].idefiscal;
        var monto = recordsAfterPagingAndSorting()[index].monto;
        var montoiva = recordsAfterPagingAndSorting()[index].montoiva;
        var idproveedor = recordsAfterPagingAndSorting()[index].idproveedor;
        var idcordinacion = recordsAfterPagingAndSorting()[index].idcordinacion;
        var idusuario_crea = recordsAfterPagingAndSorting()[index].idusuario_crea;
        var fecha_crea = recordsAfterPagingAndSorting()[index].fecha_crea;
        var fecha_reverso = recordsAfterPagingAndSorting()[index].fecha_reverso;
        var idusuario_reversa = recordsAfterPagingAndSorting()[index].idusuario_reversa;
        var reversado = recordsAfterPagingAndSorting()[index].reversado;
        var motivo = recordsAfterPagingAndSorting()[index].motivo;
        var razonsocial = recordsAfterPagingAndSorting()[index].razonsocial;
        var idordenservicio = recordsAfterPagingAndSorting()[index].idordenservicio;


        var datos = [];
        datos.push({
            tipodocumento,
            codigoorden,
            tipoorden,
            idordencompra,
            status,
            fecha,
            observaciones,
            tipo,
            concepto,
            escredito,
            numcontrol,
            idefiscal,
            monto,
            montoiva,
            idproveedor,
            idcordinacion,
            idusuario_crea,
            fecha_crea,
            fecha_reverso,
            idusuario_reversa,
            reversado,
            motivo,
            razonsocial,
            idordenservicio
        });
        setValues(datos);

    };

    return (
        <Modal
            {...props}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            size="lg"
            backdrop="static"
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            keyboard={false}
            onShow={() => {
                seleccionarOrdenesCompras()
            }}
        >
            <Modal.Header className='azulGradiant header-modal'>
                <div className="fw-bold text-light"><h3>{'Seleccionar Solicitud - ' + props.titleselect}</h3></div>
                <button ref={btnCancela} className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>
            </Modal.Header>
            <Modal.Body>
                <Mensaje mensaje={mensaje}
                    onHide={() => setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })} />
                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className="col-md-12 m-0">

                    <div className="input-group input-group-sm mb-3 m-0 col-md-5">
                        <input type='text'
                            onChange={handleSearch} className="form-control rounded-pill search-input" />
                    </div>
                </div>
                <div className="col-md-12" style={{ margin: "auto" }} >
                    <TblContainer >
                        <TblHead />

                        <tbody>
                            {
                                records && recordsAfterPagingAndSorting().map((item, index) => (
                                    <tr key={index} style={{ padding: "0", cursor: 'pointer', background: itemSelect === index ? "lightskyblue" : "white" }} onClick={seleccionarFila(index)} >
                                        <td className='py-2 text-center' style={{ width: '60px' }}>{item.codigoorden}</td>
                                        <td className='py-2 text-center' style={{ width: '250px' }}>{item.razonsocial}</td>
                                        <td className='py-2 text-center' style={{ width: '80px' }}>{item.concepto}</td>
                                    </tr>

                                ))
                            }
                        </tbody>

                    </TblContainer>
                    <TblPagination />

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-sm btn-success rounded-pill" disabled={activo} style={{ margin: "5px" }} onClick={selectOrden}><i className="fas fa-check-circle"> Aceptar</i> </button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}

export default CatalogoImputaciones;